import {useState} from 'react';
import {downloadFile,getErrorMessage} from '@/lib/api';
import NativeWordHistory from './NativeWordHistory';

// Index E working copies (§37.6): recorded/computed quality state only; none approves or releases anything.
export const INDEX_E=[['E_REVIEW_NOTES','Ringkasan catatan reviu','e_review_notes'],['E_EQR','Status EQR','e_eqr'],
 ['E_QUALITY_GATES','Ringkasan quality gate','e_quality_gates'],['E_ARCHIVE_READINESS','Kesiapan arsip dan binder','e_archive_readiness']];

export default function IndexEExports({id}){
 const [error,setError]=useState('');
 const exportCopy=async(type)=>{setError('');
  try{await downloadFile(`/engagements/${id}/word-export?export_type=${type}`,`${type}.docx`);}catch(e){setError(getErrorMessage(e));}};
 return <section className="bg-white border border-border rounded-sm p-4 space-y-3 text-xs" aria-label="Ekspor Indeks E" data-testid="index-e-exports">
  <div className="font-head font-semibold text-sm">Indeks E — Mutu dan arsip (salinan kerja Word)</div>
  <p className="text-muted-foreground">Menyajikan status yang tercatat atau dihitung sistem saat ekspor. Salinan kerja ini tidak menyetujui, menutup atau merilis apa pun.</p>
  {error&&<p role="alert">{error}</p>}
  {INDEX_E.map(([type,label,prefix])=><div key={type} className="border rounded p-2 space-y-2">
   <button type="button" className="border rounded p-2" onClick={()=>exportCopy(type)}>Ekspor {label} (Word)</button>
   <NativeWordHistory id={id} exportType={type} recordId={`${prefix}:${id}`} templates={false} pagination={false}/>
  </div>)}
 </section>;
}
